import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import TableHeaderCheckboxAll from '../../../../../components/Table/CheckAll';
import RatesList from '../List';

const RateCard = ({ ratesState, handleSelect, onChangeCheck, filteredRates, values, config, setRatesState, isFetchingList }) => {
  const { t } = useTranslation();

  const onChangeType = (type, value, id) => {
    setRatesState(
      ratesState.map((rate) => {
        if (id === rate.id) {
          return {
            ...rate,
            percent: type,
            price: value,
          };
        }
        return rate;
      }),
    );
  };

  const onChangeRatesValue = (value, id) => {
    setRatesState(
      ratesState.map((rate) => {
        if (id === rate.id) {
          return {
            ...rate,
            price: value,
          };
        }
        return rate;
      }),
    );
  };

  const checkAllTitle = () => {
    const flatterRatesId = filteredRates.map((item) => item.custom_id);
    return values.filter(Number).filter((item) => flatterRatesId.includes(item));
  };

  return (
    <div className="card__body" style={{ overflow: isFetchingList ? 'hidden' : 'auto', pointerEvents: isFetchingList ? 'none' : 'auto' }}>
      <>
        {ratesState.length === 0 ? (
          <div className="body__empty">You don't have any custom rates yet</div>
        ) : (
          <>
            {isFetchingList && <div className="modal-loader-small" />}
            <div className="body__head">
              <Table className="table-grey user-rates__table mb-0">
                <thead>
                  <tr>
                    <TableHeaderCheckboxAll
                      handleSelect={handleSelect}
                      values={checkAllTitle()}
                      transKey="Table.MassCounterUserRate"
                      transValue="{{count}} services selected"
                      onChangeCheck={(e) => onChangeCheck(e, 'checkAll')}
                      accessMassActions={[
                        { title: t('ActionsList.Edit rates'), id: 1 },
                        { title: t('ActionsList.Delete rates'), id: 2 },
                      ]}
                      toolbarClass="user-rates__table-check-drop"
                      pullRight={false}
                    />
                    <th className="service">Service</th>
                    <th className="rate">Service rate</th>
                    <th>Custom rate</th>
                  </tr>
                </thead>
              </Table>
            </div>

            <RatesList
              filteredRates={filteredRates}
              values={values}
              onChangeCheck={onChangeCheck}
              onChangeType={onChangeType}
              onChangeRatesValue={onChangeRatesValue}
              config={config}
            />
          </>
        )}
      </>
    </div>
  );
};

RateCard.propTypes = {
  ratesState: PropTypes.array,
  handleSelect: PropTypes.func,
  onChangeCheck: PropTypes.func,
  filteredRates: PropTypes.array,
  values: PropTypes.array,
  config: PropTypes.object,
  setRatesState: PropTypes.func,
  isFetchingList: PropTypes.bool,
};

export default RateCard;
